import Vue from 'vue'

import VuetifyToast from 'vuetify-toast-snackbar'

Vue.use(VuetifyToast)
